import { resolveSmartTagBrand } from 'library/ts/utilities/modules/brand/ResolveSmartTagBrand';
import { TTagBrand } from 'tag/ts/tag/types/TTagBrand';

/**
 * Resolves current brand from optional URL `forceBrand`, registry, or DOM. Shared so callers can get brand
 * without TagUtilities instance (avoids circular deps where needed).
 *
 * @see {@link TagUtilities.getBrand} Public API (delegates here)
 */
export function getBrand(): TTagBrand {
	return resolveSmartTagBrand();
}